import { Component, Input } from "@angular/core";

@Component({
  selector: "capsule",
  templateUrl: "./capsule.component.html",
  styleUrls: ["./capsule.component.scss"],
})
export class CapsuleComponent {
  @Input()
  name: string = "Testing";

  @Input()
  number: number = 20;

  @Input()
  iconName: string = "";

  /**
   * Component Starting
   * @retrun void
   */
  ngOnInit() {}
}
